import React, { type JSX } from "react";
import { useMaintenanceMode } from "./settings/useMaintenanceMode";
import { useThresholdOverrides } from "./settings/useThresholdOverrides";
import { useTimezoneSetting } from "./settings/useTimezoneSetting";
import SettingsAlerts from "./settings/SettingsAlerts";
import MaintenanceModeSection from "./settings/MaintenanceModeSection";
import ThresholdOverridesSection from "./settings/ThresholdOverridesSection";
import DisplaySettingsSection from "./settings/DisplaySettingsSection";

export default function SettingsView(): JSX.Element {
  const maintenance = useMaintenanceMode();
  const thresholds = useThresholdOverrides();
  const timezone = useTimezoneSetting();

  if (maintenance.loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900">Settings</h2>
      </div>

      <SettingsAlerts error={maintenance.error} success={maintenance.success} />

      <MaintenanceModeSection maintenance={maintenance} />
      <ThresholdOverridesSection state={thresholds} />
      <DisplaySettingsSection timezone={timezone} />
    </div>
  );
}
